import React from 'react';
import Sidebar from '../../student/Sidebar/Sidebar';
import StartScreen from '../../Start/StartScreen';

export default function Attendance() {
  return (
    <StartScreen>
      <Sidebar>A</Sidebar>
    </StartScreen>
  );
}
